import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";

import { RevCollabSession } from "@/features/rev-collab/rev-collab-session";
import { useRouteParam } from "@/lib/use-route-param";

export const Route = createFileRoute("/revCollab/revisions/$revisionId")({
  component: RevCollabRevisionPage,
});

export function RevCollabRevisionPage() {
  const revisionId = useRouteParam("revisionId");

  if (!revisionId) {
    return (
      <div className="py-10 text-sm text-muted-foreground">Invalid revision route.</div>
    );
  }

  return (
    <div className="h-full overflow-hidden">
      <RevCollabSession revisionId={revisionId as Id<"projectDocumentRevisions">} />
    </div>
  );
}
